function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import applyReducer from './applyReducer';
import reportDocumentConstants from '../constants/reportDocumentConstants';
const initState = {
  pdfPath: null,
  downloadPDFPath: null,
  annotations: [],
  displayName: 'loading...',
  error: null,
  parentReportID: null,
  reportDocumentID: null,
  reportTypeID: null
};
const renderSuccess = (state, {
  pdfPath,
  displayName,
  annotations,
  parentReportID,
  reportDocumentID,
  reportTypeID
}) => _objectSpread(_objectSpread({}, state), {}, {
  pdfPath,
  displayName,
  annotations,
  parentReportID,
  reportTypeID,
  reportDocumentID
});
const renderFailure = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  error: `Failed to render report document with ID: ${action.reportDocumentID}`
});
const reset = state => _objectSpread(_objectSpread({}, state), initState);
const clearDownloadPDFPath = state => _objectSpread(_objectSpread({}, state), {}, {
  downloadPDFPath: null
});
const renderAnnotatedSuccess = (state, {
  data: {
    downloadPDFPath
  }
}) => _objectSpread(_objectSpread({}, state), {}, {
  downloadPDFPath
});
const renderAnnotatedFailure = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  error: `Failed to render annotated report document with ID: ${action.reportDocumentID}`
});
const reducers = {
  [reportDocumentConstants.RENDER_FAILURE]: renderFailure,
  [reportDocumentConstants.RENDER_SUCCESS]: renderSuccess,
  [reportDocumentConstants.RESET]: reset,
  [reportDocumentConstants.RENDER_ANNOTATED_FAILURE]: renderAnnotatedFailure,
  [reportDocumentConstants.RENDER_ANNOTATED_SUCCESS]: renderAnnotatedSuccess,
  [reportDocumentConstants.CLEAR_DOWNLOAD_PATH]: clearDownloadPDFPath
};
export default applyReducer(reducers, initState);